import { roundHalfUp } from "@utils/roundHalfUp"

import { valueIsDefined } from "../../core/utils/utils"


function getPriceBookItemPartContext(priceBookItem) {
    const separator = valueIsDefined(priceBookItem.manufacturer) && valueIsDefined(priceBookItem.part_number) ? " \u2022 " : ""
    return `${priceBookItem.manufacturer || ""}${separator}${priceBookItem.part_number || ""}`
}


function validateVendorPartCost(allVendorPartCosts, vendorPartCost, vendorPartCostIndex) {
    let isValid = true
    let errors = {}

    const matchingVendorPartCost = allVendorPartCosts.find(comparison => vendorPartCost.vendor === comparison.vendor)
    const matchingIndex = allVendorPartCosts.findIndex(comparison => vendorPartCost.vendor === comparison.vendor)

    if (matchingVendorPartCost && vendorPartCostIndex !== matchingIndex) {
        isValid = false
        errors.non_field_error = "Another vendor cost for this vendor already exists."
    }

    if (!valueIsDefined(vendorPartCost.vendor_cost)) {
        isValid = false
        errors.vendor_cost = "Cost is required."
    }
    else if (!(vendorPartCost.vendor_cost >= -9999999.99 && vendorPartCost.vendor_cost <= 9999999.99)) {
        isValid = false
        errors.vendor_cost = "Cost must be between -9999999.99 and 9999999.99"
    }

    if (!valueIsDefined(vendorPartCost.vendor_part_number)) {
        isValid = false
        errors.vendor_part_number = "Part Number cannot be blank."
    }

    return { isValid, errors }
}


export async function fetchPriceBookClientOverrides(clientID) {
    const query = `?external_client=${clientID}`
    const [itemOverridesResponse, generalOverridesResponse] = await Promise.all([
        fetch(DjangoUrls["pricebook:api-pricebookitem-client-overrides-list"](window.MARKETPLACE_ENTITY_SLUG) + query),
        fetch(DjangoUrls["pricebook:api-pricebookitem-client-general-overrides-list"](window.MARKETPLACE_ENTITY_SLUG) + query),
    ])

    return {
        itemOverrides: itemOverridesResponse.ok ? await itemOverridesResponse.json() : [],
        generalOverrides: generalOverridesResponse.ok ? await generalOverridesResponse.json() : [],
    }
}


// A client's per-item override wins over its general override for the item's type.
export function getPriceBookItemClientPrice(priceBookItem, itemOverrides, generalOverrides) {
    const itemOverride = itemOverrides.find((override) => override.pricebook_item.id === priceBookItem.id)
    const generalOverride = generalOverrides.find(
        (override) => override.pricebook_item_type === priceBookItem.pricebook_item_type,
    )
    const defaultPrice = parseFloat(priceBookItem.default_price)

    if (itemOverride) {
        return parseFloat(itemOverride.price)
    }
    else if (generalOverride) {
        return roundHalfUp(defaultPrice * (1 + parseFloat(generalOverride.price_adjustment_percent) / 100), 3)
    }
    else {
        return defaultPrice
    }
}


export function getPricebookTaxById(tax_id, priceBookTaxes) {
    return priceBookTaxes?.find(tax => tax.id === tax_id) || null
}


export function getPricebookTaxByName(tax_name, priceBookTaxes) {
    return priceBookTaxes?.find(tax => tax.description === tax_name) || null
}

export function renderVendorString(vendor) {
    return `${vendor.name}${vendor.is_active ? "" : " (inactive)"}`
    }


export { getPriceBookItemPartContext, validateVendorPartCost }
